var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".developing{margin-top:3.2rem;padding-top:36%;color:#333;font-size:.48rem;text-align:center;background:url(" + escape(require("../../../static/img/yemian-bg.png")) + ") top no-repeat;background-size:30%}.developing .small{padding-top:.133333rem;color:#666;font-size:.346667rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dabf38ae","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/developing/developing.vue
// module id = 489
// module chunks = 0